export class TableContextRelease {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "summary",
            "baseName": "summary",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "kindNotes",
            "baseName": "kindNotes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "segmentBy",
            "baseName": "segmentBy",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextRelease.attributeTypeMap;
    }
    constructor() {
    }
}
